<template>
  <div class="login-wrap">
    <div class="row">
      <div class="col-sm-8 text-center col-sm-offset-2 col-md-6 col-md-offset-3 col-lg-4 col-lg-offset-4 push-50-t">
        <img src="../../assets/images/logo-login.png" alt="">
        <h2 class="push-50-t">{{ labelFieldTitle[actualLanguage] }}</h2>
        <div v-if="errorMsg" class="alert push-30-t alert-danger alert-dismissable">
          <p>{{errorMsg}}</p>
        </div>
        <div v-if="notif" class="alert push-30-t alert-success alert-dismissable">
          <p>{{notif}}</p>
        </div>


        <form class="simple_form form-horizontal push-50-t" novalidate="novalidate" id="new_user"
              action="/lobby/connexion" accept-charset="UTF-8" method="post"><input name="utf8" type="hidden" value="✓"><input
          type="hidden" name="authenticity_token"
          value="Ahic++4LN7D6ofsViOL59IWMgE7/qyXEiqG8ApI4fBU+CXupmcktQPQ19HxfIKmW2lGSWB4L+DcKWi9eQQPY/g==">
          <div class="form-inputs">
            <div class="form-group">
              <div class="col-xs-12 ">
                <div class="form-material form-material-primary">
                  <input :disabled="isWorking" v-model="email" class="form-control string email optional form-control"
                         autofocus="autofocus" type="email" value="" name="user[email]" id="user_email">
                  <label for="user_email">{{ labelFieldEmail[actualLanguage] }}</label>
                </div>
              </div>
            </div>
    
            <div class="form-group">
              <div class="col-xs-12 ">
                <div class="form-material form-material-primary">
                  <input :disabled="isWorking" v-model="password" class="form-control password optional form-control"
                         type="password" id="user_password">
                  <label for="user_password">{{ labelFieldPW[actualLanguage] }}</label>
                </div>
              </div>
            </div>


          </div>

          <div class="form-actions">
            <div class="col-xs-12 text-center push-30-t">
              <div v-if="!isWorking">
                <button type="button" @click="signIn" style="min-width: 250px" class="btn btn-connexion btn-success">{{
                  labelFieldButtonConnect[actualLanguage] }}
                </button>
                <div class="row" style="padding-top: 10px">
                  <router-link type="button"  style="font-weight: bold" class="" :to="{name: 'forgotPW'}">
                    {{ labelFieldButtonForgotPW[actualLanguage] }}
                  </router-link>
                </div>

              </div>

              <spinner v-else></spinner>
            </div>
          </div>


          <div class="row">
            <div class="col-sm-12 text-center" style="margin-top: 100px">
              <p>{{ labelFieldTextFirstTime[actualLanguage] }}
                <router-link style="margin-left: 5px" class="btn btn-default btn-rounded" :to="{name: 'register'}">
                  {{ labelFieldButtonSubscribe[actualLanguage] }}
                </router-link>
              </p>
            </div>
          </div>

          <div class="form-actions">
            <div class="col-xs-12 text-center push-30-t">
              <button v-if="!isWorking" type="button" @click="toggleLanguage" style="min-width: 250px"
                      class="btn btn-default btn-rounded">{{ labelFieldButtonLanguage[actualLanguage] }}
              </button>

            </div>
          </div>

        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import Spinner from '../../components/Spinner'

  export default {
    components: {
      Spinner
    },
    name: 'login',
    data() {
      return {
        email: '',
        password: '',
        isWorking: false,
        errorMsg: '',
        notif: '',
        name: '',
        lastName: '',

        actualLanguage: "FR",
        labelFieldTitle: {FR: 'Connectez-vous', EN: 'Login'},
        labelFieldButtonLanguage: {FR: 'English version', EN: 'Version française'},
        labelFieldEmail: {FR: 'Adresse courriel', EN: 'Email'},
        labelFieldPW: {FR: 'Mot de passe', EN: 'Password'},
        labelFieldButtonConnect: {FR: 'Connexion', EN: 'Connect'},
        labelFieldTextFirstTime: {FR: "C'est votre première fois ?", EN: 'This is your first time ?'},
        labelFieldButtonSubscribe: {FR: 'Inscription', EN: 'Subscribe'},
        labelFieldButtonForgotPW: {FR: 'Mot de passe oublié?', EN: 'Forgot password?'}
      }
    },

    computed: {
      ...mapState('sessionStore', ['userEmail']),
      ...mapState('sessionStore', ['userName']),
      ...mapState('sessionStore', ['userLastName']),

    },

    mounted() {
      this.email = this.userEmail
      this.name = this.userName
      this.lastName = this.userLastName

      //do something after mounting vue instance
      this.isWorking = false
      if (this.$router.currentRoute.params.notif) {
        this.notif = this.$router.currentRoute.params.notif
      }

      if (localStorage.language) {
        this.actualLanguage = localStorage.language
      } else {
        this.actualLanguage = 'FR'
      }
    },

    methods: {
      signIn() {
        this.isWorking = true
        this.$store.dispatch('sessionStore/signIn', {
          email: this.email,
          password: this.password,
          name: this.name,
          lastName: this.lastName,
          language: this.actualLanguage
        })
          .then(() => {
            this.$store.dispatch('sessionStore/refreshProfileData')
              .then((response) => {
                //console.log("measurement_routing");
                this.$router.push({name: 'measurements'})
              })
          })
          .catch((e) => {
            this.errorMsg = e.message;
            this.isWorking = false
          })
      },

      toggleLanguage() {
        if (this.actualLanguage == 'FR') {
          this.actualLanguage = 'EN'
          localStorage.language = 'EN'
        } else {
          this.actualLanguage = 'FR'
          localStorage.language = 'FR'
        }
        location.reload()
      }

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// Login.vue?0ae14527